/* Code copyright 2019 (c) Tuva Labs Inc. */
/**
 *
 * created by Naveenkumar Ganesan
 */

import React from 'react';

class DurationInputComponent extends React.Component {

  state = {}

  onChange = ( e ) => {
    var value = e.target.value;
    this.internalUpdate = true;
    this.setState({
      value: value
    });

    // check the string, converting to a numeric value
    //  e.g. "00:12" => 12, "1/2" => 0.5 for Dyn.dataUtil.subtypes.kDurationHMS, kFraction
    const subType = this.props.attributeObj.subType, attrType = this.props.attributeObj.getDataType();
    let isAcceptable, numericValue, dataFormat = {};
    if( subType ) {
      this.props.Dyn.dataUtil.getDataType( value, dataFormat, attrType, subType );
      numericValue = dataFormat.value;
      isAcceptable = dataFormat.subtype === subType;
    } else {
      // convert input string for an ordinary numeric Attribute (no subtype)
      numericValue = value;
      isAcceptable = (value !== "" && value.substring(value.length-1) != ".")
    }

    if( isAcceptable ) {
      this.delayParentChange( numericValue );
    } else {
      // Cancel input change pass to parent when invalid characters are typed
      clearTimeout(this.inputChangeTimeout);
      this.inputChangeTimeout = null;
    }
  }

  delayParentChange (value) {
    if(this.inputChangeTimeout) {
      clearTimeout(this.inputChangeTimeout);
      this.inputChangeTimeout = null;
    }
    this.inputChangeTimeout = setTimeout(function(){
      this.inputChangeTimeout = null;
      this.props.onChange(value);
    }.bind(this), 700);
  }

  onBlur = ( e ) => {
    if(this.inputChangeTimeout) {
      return;
    }
    // Reset value
    this.internalUpdate = true;
    this.setState({
      value: this._getFormattedValue(this.props.value)
    });
  }

  _getFormattedValue (value) {
    var subType = this.props.attributeObj.subType;
    if(subType) {
      return this.props.attributeObj.axisValueToString(value)
    } else {
      return value;
    }
  }

  render = () => {
    if(!this.internalUpdate) {
      this.state.value = this._getFormattedValue(this.props.value);
    } else {
      this.internalUpdate = false;
    }
    return (
      <input type="text" className={this.props.className}
        aria-label={this.props.arialabel}
        onChange={this.onChange}
        onBlur={this.onBlur}
        value={this.state.value} />
    );
  }
}

export default DurationInputComponent
